import { debounce } from 'lodash';
import { LocationOption } from '../types';

// Direct search function without debounce
const searchLocations = async (inputValue: string): Promise<LocationOption[]> => {
    if (inputValue.length < 3) {
        return [];
    }

    console.log('Making API call for:', inputValue);

    try {
        const response = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(inputValue)}&limit=5&addressdetails=1&accept-language=en`
        );

        if (!response.ok) {
            throw new Error('Failed to fetch location data');
        }

        const data = await response.json();

        const options = data
            .filter((item: any) =>
                item.addresstype !== 'state' &&
                item.addresstype !== 'country' &&
                item.lat &&
                item.lon
            )
            .map((item: any) => {
                const city = item.address.city || item.address.town || item.address.village || item.address.municipality || '';
                const state = item.address.state_code || item.address.state || item.address.region || '';
                const country = item.address.country || '';

                const displayName = [city, state, country].filter(Boolean).join(', ');

                return {
                    value: displayName,
                    label: displayName,
                    lat: parseFloat(item.lat),
                    lon: parseFloat(item.lon)
                };
            });

        return options;
    } catch (error) {
        console.error('Error fetching location data:', error);
        return [];
    }
};

// Create a debounced version for use outside of React Select
export const debouncedLocationSearch = debounce(searchLocations, 500);

// Simple debounced search for React Select
let searchTimeout: NodeJS.Timeout | null = null;

export const loadLocationOptions = async (inputValue: string): Promise<LocationOption[]> => {
    // If input is too short, return empty array
    if (inputValue.length < 3) {
        console.log('Input too short, waiting for more characters...');
        return [];
    }

    //   console.log('Searching for:', inputValue);
    
    // Clear previous timeout
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }

    // Return a promise that resolves after a delay
    return new Promise((resolve) => {
        searchTimeout = setTimeout(async () => {
            //   console.log('Executing search for:', inputValue);
            const result = await searchLocations(inputValue);
            //   console.log('Search result:', result);
            resolve(result);
        }, 1000); // 1.5 second delay
    });
};

// Function to validate coordinates
export const validateCoordinates = (lat: number, lon: number): boolean => {
    return lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180;
};

// Function to format location display
export const formatLocationDisplay = (location: LocationOption): string => {
    return location.label;
};